import { useTranslation } from 'react-i18next';
import { useAppEnvConfig } from '@connect-x-app/hybrid-state';
import { Text } from '@connect-x-app/hybrid-ui';
import { LICENSE_ATTRIBUTION_METADATA } from '@connect-x-app/shared-license-attribution';
import { AppConfigOption } from '@connect-x-app/shared-types';
import { COLORS } from '@connect-x-app/shared-ui';
import { APP_CONFIG_TEST_IDS } from '@connect-x-app/web-test-ids';
import { toastError, toastSuccess } from '@connect-x-app/web-ui';

import { InfoItem } from '../infoItem/InfoItem';

export const Configuration = () => {
  const { t } = useTranslation();
  const { appConfig } = useAppEnvConfig();

  // The browser can refuse the clipboard (no permission, not a secure context).
  const handleCopy = async (value: string) => {
    try {
      await navigator.clipboard.writeText(value);
      toastSuccess(t('MESSAGE.COPY.COPIED'));
    } catch {
      toastError(t('TOAST_ERROR'));
    }
  };

  const metadata: AppConfigOption[] = Object.entries(LICENSE_ATTRIBUTION_METADATA).map(
    ([key, value]) => ({ label: key, value }) as AppConfigOption,
  );

  const infoItems: AppConfigOption[] = Object.entries(appConfig)
    .filter(([, value]) => value)
    .map(([key, value]) => ({ label: key, value }) as AppConfigOption)
    .concat(metadata);

  const yearRelease = new Date(LICENSE_ATTRIBUTION_METADATA.generatedAt).getUTCFullYear();

  const renderInfoItem = (appConfigOption: AppConfigOption) => {
    const infoItem = { ...appConfigOption, label: appConfigOption.label.toUpperCase() };
    const isDeviceId = appConfigOption.label === 'deviceId';

    return (
      <InfoItem
        key={infoItem.label}
        onClick={isDeviceId ? handleCopy : undefined}
        testId={isDeviceId ? APP_CONFIG_TEST_IDS.about.deviceId : APP_CONFIG_TEST_IDS.about.configuration(appConfigOption.label)}
        {...infoItem}
      />
    );
  };

  return (
    <>
      <div className="about-version-container">
        <Text className="about-version__title" color={COLORS.romeo.$06} size="SM" weight="bold">
          {t('ABOUT.APP_CONFIGURATION')}
        </Text>
        <ul>{infoItems.map(renderInfoItem)}</ul>
      </div>
      <div className="about-copyright-container">
        <Text className="about-copyright-text" color={COLORS.romeo.$06} size="SM" weight="bold">
          {t('ABOUT.COPYRIGHT')}
        </Text>
        <Text color={COLORS.zulu.$10} size="SM" weight="semiBold">
          {t('ABOUT.YEAR_RELEASE', { yearRelease })}
        </Text>
      </div>
    </>
  );
};
